import * as React from 'react';

import { useDeviceType } from '../../utils/responsive';

export const NotDesktop: React.FC = ({ children }) => {
  const deviceType = useDeviceType();

  return deviceType !== 'desktop' ? (children as React.ReactElement) : null;
};

NotDesktop.displayName = 'ResponsiveNotDesktop';
